import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { obtenerVentasAExportadorActual } from '../../../actions/listados'
import VentaAExportadoresActualView from '../../../components/ventaAExportadores/VentaAExportadorActualView'
import { COLORES } from '../../../../../config/colores'
import CamposVentasExportador from '../../../components/ventaAExportadores/CamposVentaExportador'
import { FORM_VENTA_A_EXPORTADOR } from '../../../../../config/forms'
import { formValueSelector, reduxForm } from 'redux-form'
import { venderAExportador } from '../../../actions'
import { toast } from 'react-toastify'
import moment from 'moment'

function VentasAExportador (props) {
  const { obtenerVentasAExportadorActual, change: formChange, venderAExportador } = props

  useEffect(() => {
    obtenerVentasAExportadorActual()
  }, [obtenerVentasAExportadorActual])

  const handleSubmit = () => {
    const { cerealVenta, exportadorVenta, cantidadVenta } = props
    if (cerealVenta && exportadorVenta && cantidadVenta) {
      venderAExportador()
    } else {
      toast.error('Debe completar todos los campos')
    }
  }

  const actualizarFecha = (fecha) => {
    formChange('fechaVenta', moment(fecha).format('YYYY-MM-DD'))
  }

  return (
    <>
      <div style={{
        padding: '22px',
        borderRadius: '22px',
        color: COLORES.grey.dark,
        border: '1px solid',
        borderColor: COLORES.grey.light,
        marginBottom: '3%'
      }}>
        <h5>Venta a exportadores</h5>
        <CamposVentasExportador handleSubmit={handleSubmit} actualizarFecha={actualizarFecha} />
      </div>

      <VentaAExportadoresActualView />
    </>
  )
}

const selector = formValueSelector(FORM_VENTA_A_EXPORTADOR)

const mapStateToProps = (state) => ({
  cerealVenta: selector(state, 'cerealVenta'),
  exportadorVenta: selector(state, 'exportadorVenta'),
  cantidadVenta: selector(state, 'cantidad')
})

const mapActionsToProps = {
  obtenerVentasAExportadorActual,
  venderAExportador

}

const withRedux = connect(mapStateToProps, mapActionsToProps)
const withReduxForm = reduxForm({
  form: FORM_VENTA_A_EXPORTADOR
})
export default withRedux(withReduxForm(VentasAExportador))
